export const getClusters = (mapState, markets, supercluster) => {
  if (!mapState.bounds || !markets) return null

  const bounds = [
    parseFloat(mapState.bounds?.nw?.lng),
    parseFloat(mapState.bounds?.se?.lat),
    parseFloat(mapState.bounds?.se?.lng),
    parseFloat(mapState.bounds?.nw?.lat)
  ]

  const points = markets.map(market => {
    const lat = market['address.lat']
    const lon = market['address.lon']

    return {
      type: 'Feature',
      properties: { cluster: false, market: market },
      geometry: {
        type: 'Point',
        coordinates: [parseFloat(lon), parseFloat(lat)]
      }
    }
  })

  supercluster.load(points)
  return supercluster.getClusters(bounds, mapState.zoom)
}
